export default __webpack_public_path__ + "asset/img/goods-detail-coupon-02~4b1dee55.png";